import $ from 'jquery';

import 'Lib/jquery.onMutate';

import whenDomReady from 'when-dom-ready';


whenDomReady(function(){

  var wrapWithFormGroups = function ($form) {
    $form.find('.grid~.text-center').addClass('form-group');
  
    $form.find('label').each(function () {
      var $label = $(this);
      var $input = $label.siblings('#' + $label.attr('for'));
  
      var $formGroup = $($.parseHTML('<div class="form-group"></div>'));
  
      // add custom checkbox
      if ($label.find('input[type="checkbox"]').length) {
        $label.find('input[type="checkbox"]').after('<span class="check"></span>');
        $formGroup.addClass('has-checkbox');
      }
  
      $formGroup.append($input.clone(true));
      $formGroup.append($label.clone(true));
      $formGroup.insertAfter($label);
  
      $label.remove();
      $input.remove();
    });
  };
  
  var hideUnusedFormGroups = function ($form) {
    $form.find('.form-group').each(function () {
      if ($(this).find('[style*="none"]').length) {
        $(this).css('display', 'none');
      } else $(this).css('display', '');
    });
  };
  
  $('body').onCreate('.wishl-modal', function ($modal) {
  
    $modal.onCreate('form', function ($form) {
      wrapWithFormGroups($form);
      hideUnusedFormGroups($form);
  
      $form.onModify(hideUnusedFormGroups, true);
    });
  
    $modal.onModify('style', /block/, function ($el) {
      $el.css('display', 'flex');
    }, true);
  
  });
  
})